import './edge-to-edge-table.css';

import type { SafeHtml } from 'kerfjs';

/**
 * Pane-wide, keyboard-scrollable region for an app-owned native table. `bounded` caps the
 * region's height for long reports, which then scroll inside it. Callers find the region by its
 * label, not a class (HS2-2GARDP).
 */
export function EdgeToEdgeTable({
  label,
  bounded = false,
  children,
}: {
  label: string;
  bounded?: boolean;
  children: SafeHtml | string;
}): SafeHtml {
  return (
    <div
      class="edge-to-edge-table"
      data-bounded={bounded ? '' : undefined}
      role="region"
      aria-label={label}
      tabindex={0}
    >
      {children}
    </div>
  );
}
